import { Card, CardContent, Box, Typography } from "@mui/material";
import SubMenuTooltip from "./SubMenu";

const MenuItem = ({
  menuEntry,
  isPopUpOpen,
  isActive,
  selectedMenu,
  onCardClick = () => { },
  onSubMenuClick = () => { },
  isOpenChatWidget
}) => {
  const {
    titleColor,
    labelColor,
    descriptionColor,
    icon,
    label,
    description,
    color,
  } = menuEntry;
  const headingColor = titleColor || labelColor;

  return (
    // <Card className="menu-item-card position-relative" sx={{ backgroundColor: color }}>
    <div className={isOpenChatWidget ? "bg-primarymain rounded-[14px]  px-[15px] 2xl:py-[50px] xl:py-[40px] py-[30px] text-center menu-item-card-body h-full" :
     "bg-primarymain rounded-[14px] px-[15px] 2xl:py-[50px] xl:py-[40px] py-[30px] text-center menu-item-card-body h-full max-w-[]"} onClick={onCardClick}>
      {/* <CardContent className="menu-item-card-body" onClick={onCardClick}> */}
      {/* <Box className="icon-wrapper"> */}
      {icon ? (
        <img
          src={icon}
          alt="icon"
          className="icon-img w-[55px] h-[55px] mb-[10px]"
        />
      ) : (
        <i className="icon-img" />
      )}
      {/* </Box> */}

      {/* <Typography className="menu-label" sx={{ color: headingColor }}> */}
      <h5 className="text-size-14 font-bold mb-[8px]">{label}</h5>
      {/* </Typography> */}
      {/* <Typography
          className="menu-description"
          sx={{ color: descriptionColor }}
        > */}
      <p className="text-size-14">{description}</p>
      {/* </Typography> */}

      {isPopUpOpen && isActive && (
        // <Box className="popup-menu-arrow" sx={{ backgroundColor: color }} />
        <div className=" bg-primarymain absolute bottom-[-9px] w-[19px] h-[19px] rotate-43"></div>
      )}
      {/* </CardContent> */}

      {isPopUpOpen && isActive && (
        <SubMenuTooltip
          subMenu={selectedMenu?.submenu}
          onSubMenuClick={onSubMenuClick}
        />
      )}
    </div>
    // </Card>
  );
};

export default MenuItem;
